export var WishToGo = /*#__PURE__*/function () {
  function WishToGo() {}

  WishToGo.auth = function auth() {
    return window['wtgAuth']();
  };

  WishToGo.admin = function admin() {
    return window['wtgAdmin']();
  };

  WishToGo.init = function init() {
    window['wtgInit']();
  };

  return WishToGo;
}();